import React from 'react';
import { useQueryClient } from 'react-query';
import { Modal, Form, Input } from 'antd';
import useEditRoomCommentMutation from '../../../mutations/useEditRoomCommentMutation';
import { roomQueryKeys } from '../../../queries/queryKeys';
import { stringTrim } from '../../../../../helpers/stringTrim';
import { getEditingRoomData } from '../../../utils/getEditingRoomData';

const { TextArea } = Input;

const EditRoomComment = ({ form, onCancel, visible, room }) => {
  const { resetFields, validateFieldsAndScroll, getFieldDecorator } = form;

  const queryClient = useQueryClient();

  const {
    mutateAsync: editCommentMutateAsync,
    isLoading: isEditCommentLoading,
  } = useEditRoomCommentMutation({
    onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
  });

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        const data = getEditingRoomData(room);

        await editCommentMutateAsync({
          room: data,
          comment: stringTrim(fieldValues.comment),
        });
        handleCancel();
      }
    });
  };

  const compareToInitialValue = (_rule, value, callback) => {
    if (value && value.trim() === room?.comment.trim()) {
      callback('Комментарий не изменен');
    } else {
      callback();
    }
  };

  return (
    <Modal
      visible={visible}
      title={room?.comment ? 'Изменить комментарий' : 'Добавить комментарий'}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={room?.comment ? 'Изменить' : 'Добавить'}
      confirmLoading={isEditCommentLoading}
      destroyOnClose
    >
      <Form>
        <Form.Item label="Комментарий">
          {getFieldDecorator('comment', {
            initialValue: room?.comment,
            rules: [
              {
                required: true,
                message: 'Напишите комментарий',
                whitespace: true,
              },
              {
                validator: compareToInitialValue,
              },
            ],
          })(<TextArea rows={4} />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EditRoomCommentModal = Form.create({ name: 'edit_room_comment' })(
  EditRoomComment
);

export default EditRoomCommentModal;
